export default __webpack_public_path__ + "f38b5d0aee025c036dc95475baba55f6.png";